import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportRegistrationMasterdataComponent } from './component/transport-registration-masterdata.component';
import { CenteredScrollableContentModule } from 'src/tmc-common/widgets/terminal/centered-scrollable-content/centered-scrollable-content.module';
import { CommonLayoutModule, CommonTranslationModule } from '@sdbn/common';
import { TransportDetailsModule } from 'src/tmc-yard/common/components/transport-details/transport-details.module';



@NgModule({
  declarations: [
    TransportRegistrationMasterdataComponent
  ],
  imports: [
    CommonModule,
    TransportDetailsModule,
    CenteredScrollableContentModule,
    CommonLayoutModule,
    CommonTranslationModule
  ]
})
export class TransportRegistrationMasterdataModule { }
